import { getTemplate } from "../template-helper";

const COMPONENT_NAME = "z-error-feedback" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class ButtonDeleteComponent extends HTMLElement {
            constructor() {
                super();
                const clone = document.importNode(template.content, true);
                this.appendChild(clone);

                this.alert = this.querySelector("div.alert") ;
            }

            get value() {
                return this.alert.innerHTML ;
            }
            
            set value(value) {
                this.alert.innerHTML = value ;
                if(value){
                    this.alert.classList.remove("d-none") ;
                } else {
                    this.alert.classList.add("d-none") ;
                }
            }
           
        }
        customElements.define(COMPONENT_NAME, ButtonDeleteComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
